import { infer as Infer, z } from 'zod';

export const postCreateSchema = z.object({
  name: z.string().min(1, 'Tytuł jest wymagany'),
  content: z.string().min(1, 'Treść jest wymagana'),
  active: z.boolean(),
  publishedAt: z.string().nullable(),
  attachments: z.array(z.file()).optional(),
  groups: z.array(z.int()).optional(),
  global: z.boolean(),
});

export type PostCreateSchema = Infer<typeof postCreateSchema>;
